export class User {
  
   public static getSenderName = (bananaOperation: any): string => {
    if (!bananaOperation) {
      return "Bananonymous";
    }
    let senderNameText = bananaOperation?.senderName || "";
    if (senderNameText.trim().length > 0) {
      if (!!bananaOperation?.sender?.username) {
        senderNameText = `${senderNameText} (@${bananaOperation?.sender?.username})`;
      }
    } else {
      if (bananaOperation?.sender?.username?.length > 0) {
        senderNameText = `@` + bananaOperation?.sender?.username
      } else {
        senderNameText = "Bananonymous";
      }
    }
    return senderNameText;
  }
}